import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import I18n from 'I18n';
import { Select } from 'foundations-components/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { fromJS } from 'immutable';
import { INTERACTION_SECTIONS } from '../../constants/PageInteractionTracking';
import usePageInteractionTracking from '../../hooks/usePageInteractionTracking';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { getShowAllErrors, setErrorMessages } from '../../state/errorMessagesSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormFieldSelect = ({
  disabled,
  formField
}) => {
  var _formState$get$get;
  const {
    formState,
    dispatch
  } = usePaymentFormContext();
  const {
    trackFirstFormFieldInteraction
  } = usePageInteractionTracking();
  const reduxDispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const {
    label,
    options,
    required
  } = formField;
  const fieldName = formField.name;
  const selectedValue = (_formState$get$get = formState.get('customData').get(fieldName)) === null || _formState$get$get === void 0 ? void 0 : _formState$get$get.toArray();
  const isError = formField.required && (showAllErrors || hasBeenBlurred) && !selectedValue;
  const errorKey = `empty${label}`;
  const errorMessage = useGetErrorMessagesAndTranslations().get(errorKey);
  useEffect(() => {
    reduxDispatch(setErrorMessages({
      [errorKey]: {
        isError,
        customFormFieldLabel: label
      }
    }));
  }, [isError, reduxDispatch, label, errorKey]);
  const uiSelectOptions = useMemo(() => options.map(option => ({
    text: option.label,
    value: option.value,
    key: option.value
  })), [options]);
  const handleSelect = useCallback(({
    value
  }) => {
    trackFirstFormFieldInteraction({
      section: INTERACTION_SECTIONS.contactInfo,
      target: fieldName
    });
    dispatch({
      type: 'setField',
      data: {
        propertyPath: ['customData', fieldName],
        value: fromJS([value])
      }
    });
  }, [dispatch, fieldName, trackFirstFormFieldInteraction]);
  return /*#__PURE__*/_jsx(FormControl, {
    help: formField.description,
    label: label,
    required: required,
    error: isError,
    validationMessage: isError && errorMessage,
    paddingBlockStart: "100",
    children: /*#__PURE__*/_jsx(Select, {
      searchable: true,
      referenceVariant: "on-dark",
      "data-test-id": "custom-form-field-select",
      disabled: disabled,
      onSelectedOptionChange: handleSelect,
      options: uiSelectOptions,
      selectedItemsPlaceholder: I18n.text('payments.contactInfo.selectPlaceholder'),
      selectedValues: selectedValue,
      onOpenChange: isOpen => {
        if (!isOpen) {
          setHasBeenBlurred(true);
        }
      }
    })
  });
};
export default CustomFormFieldSelect;